import React, { FC, useEffect } from 'react';
import useSwr from 'swr';
import toast from 'react-hot-toast';
import cn from 'clsx';
import { differenceInMinutes, formatDistanceToNow, isFuture } from 'date-fns';

import { Transition } from '@headlessui/react';

import { useAuth } from '@hooks/Auth';
import { listPopUps } from '@sdk/managers/AlertManager';
import { PopUpType } from '@sdk/API';
import { getImageUrl } from '@utils/image';
import { useHistory } from 'react-router';

interface PopupModuleProps {}

// listPopUps

const POPUP_MESSAGE = {
  [PopUpType.POLL_INSERT]: 'New Poll created',
  [PopUpType.VOTE_INSERT]: 'New Vote',
  [PopUpType.PLEDGE_INSERT]: 'New Pledge',
};

const SHOW_POPUP_TYPES = [
  PopUpType.POLL_INSERT,
  PopUpType.VOTE_INSERT,
  PopUpType.PLEDGE_INSERT,
];

const POPUP_STORAGE_KEY = 'LAST_POPUP';

const IGNORE_PATHS = [
  '/',
  '/signup',
  '/reset-password',
  '/profile/setup',
  '/company/setup',
  '/verify',
];

const PopupModule: FC<PopupModuleProps> = ({}) => {
  const history = useHistory();
  const pathname = history?.location?.pathname;

  const [show, setShow] = React.useState<boolean>(false);
  const { data: popup } = useSwr(
    IGNORE_PATHS.includes(pathname) === false ? ['/poll/popups'] : null,
    async () => {
      const popups: any = await listPopUps();
      const popup = popups.data?.result?.items?.filter((popup) =>
        SHOW_POPUP_TYPES.includes(popup.type)
      )?.[0];
      if (!popup) return undefined;
      const lastKey = localStorage.getItem(POPUP_STORAGE_KEY);

      if (lastKey === popup.pollID + popup.updatedAt) {
        return undefined;
      }

      popup.updatedDate = new Date(popup.updatedAt);
      if (Math.abs(differenceInMinutes(new Date(), popup.updatedDate)) > 30)
        return undefined;

      if (popup.poll?.image) {
        popup.imageSrc = await getImageUrl(popup.poll?.image);
      }

      console.log('popup', popup);
      let timerShow = setTimeout(() => {
        if (popup) {
          localStorage.setItem(
            POPUP_STORAGE_KEY,
            popup.pollID + popup.updatedAt
          );
          setShow(true);
          setTimeout(() => {
            setShow(false);
          }, 15000);
        }
      }, 5000);

      return popup;
    },
    {
      refreshInterval: 30000,
      errorRetryCount: 5,
      onError: async (err, key) => {
        console.log('Failed to fetch popup', { key }, err);
        if ((err.data?.result?.items?.length || 0) > 0) {
          const popup = err.data?.result?.items?.filter((popup) =>
            SHOW_POPUP_TYPES.includes(popup)
          )?.[0];
          if (!popup) return undefined;

          const lastKey = localStorage.getItem(POPUP_STORAGE_KEY);
          console.log(
            'displaying',
            popup,
            err.data?.result?.items,
            'last',
            lastKey
          );

          if (lastKey === popup.pollID + popup.updatedAt) {
            return undefined;
          }

          popup.updatedDate = new Date(popup.updatedAt);
          if (Math.abs(differenceInMinutes(new Date(), popup.updatedDate)) > 30)
            return undefined;

          if (popup.poll?.image) {
            popup.imageSrc = await getImageUrl(popup.poll?.image);
          }

          console.log('popup', popup);
          let timerShow = setTimeout(() => {
            if (popup) {
              localStorage.setItem(
                POPUP_STORAGE_KEY,
                popup.pollID + popup.updatedAt
              );
              setShow(true);
              setTimeout(() => {
                setShow(false);
              }, 15000);
            }
          }, 5000);
        }
      },
    }
  );

  if (!popup) return <></>;

  const distance = formatDistanceToNow(popup.updatedDate);
  const isFuturePopup = isFuture(popup.updatedDate);

  if (!POPUP_MESSAGE[popup.type]) {
    return <></>;
  }

  return (
    <Transition
      show={show}
      enter="transition duration-1000 ease-in-out transform"
      enterFrom="opacity-0 translate-y-8"
      enterTo="opacity-100 translate-y-0"
      leave="transition duration-700 ease-in-out transform"
      leaveFrom="opacity-100 translate-y-0"
      leaveTo="opacity-0 -translate-y-4"
      className="absolute right-0 z-20 bottom-32"
    >
      <div
        role="button"
        className="flex p-4 mr-4 bg-white rounded-lg shadow-lg"
        // onClick={() => history.push(`/poll/${popup.pollID}`)}
      >
        <div
          className={cn({
            'w-16 h-16 mr-4': !!popup.imageSrc,
          })}
        >
          {popup.imageSrc && (
            <img
              src={popup.imageSrc}
              alt={popup.poll?.title}
              className="object-cover w-full h-full"
            />
          )}
        </div>
        <div>
          <div className="font-semibold">{POPUP_MESSAGE[popup.type]}</div>
          <div className="text-sm ">{popup.poll?.title}</div>

          <div className="text-sm font-semibold">
            {isFuturePopup ? `In ${distance}` : `${distance} ago`}
          </div>
        </div>
      </div>
    </Transition>
  );
};

export default PopupModule;
